<template>
  <div class="printBox page5 common">
    <div class="bg-t"></div>
    <div class="content">
      <div class="chart-content">
        <div class="chartBox">
          <div style="font-size: 21px;color: #000;">C、大脑疲劳度</div>
          <div class="chart1" ref="chartRef1" style="width: 100%;height: 100%;">
            
          </div>
        </div>
        <div class="chartBox">
          <div style="font-size: 24px;color: #0066CC;margin-bottom: 20px;">2、心理状态指标统计分析（SCL-90映射指标）</div>
          <div class="chart2" ref="chartRef2" style="width: 100%;height: 100%;">
            
          </div>
        </div>
      </div>
    </div>
    <div class="bg-b"></div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import * as echarts from "echarts";

const props = defineProps(["data"]);

const chartRef1 = ref(null);
const chartRef2 = ref(null);
let chartInstance1 = null;
let chartInstance2 = null;

const init = () => {
  chartInstance1 = echarts.init(chartRef1.value);
  chartInstance2 = echarts.init(chartRef2.value);
};

onMounted(() => {
  nextTick(() => {
    init();
  })
});

watch(
  () => props.data,
  (val) => {
    setChart1(val.brainResultList);
    setChart2(val.indicatorResultList);
  },
  { deep: true }
);

const setChart1 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '大脑疲劳度预警图',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: '0',
      top: 'middle',
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        label: {
          fontSize: 12,
          formatter: ({ name, percent, value }) => {
            return `${name}\n人数：${value}\n占比 ${percent.toFixed(2)}%`;
          }
        },
        data: val.map((item) => {
          return {
            name: item.result,
            value: item.peopleData.numberPeople,
          }
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
  chartInstance1 && chartInstance1.setOption(option);
}
const setChart2 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '心理状态指标统计分析图',
      left: 'center',
      top: '20px'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // Use axis to trigger tooltip
        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
      }
    },
    legend: {},
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'value'
    },
    yAxis: {
      type: 'category',
      data: []
    },
    series: []
  };
  option.yAxis.data = val.map((item) => {
    return item.name;
  })
  option.series = [
    {
      name: '正常',
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        formatter: ({data}) => {
          if(data.value == 0){
            return ''
          }
          return `人数：${data.value}人\n占比：${(data.per).toFixed(2)}%`
        },
        fontSize: 10,
      },
      emphasis: {
        focus: 'series'
      },
      data: val.map((item) => {
        return {
          value:item.normalData.numberPeople,
          per:item.normalData.proportion
        }
      })
    },
    {
      name: '轻微',
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        formatter: ({data}) => {
          if(data.value == 0){
            return ''
          }
          return `人数：${data.value}人\n占比：${(data.per).toFixed(2)}%`
        },
        fontSize: 10,
      },
      emphasis: {
        focus: 'series'
      },
      data: val.map((item) => {
        return {
          value:item.slightData.numberPeople,
          per:item.slightData.proportion
        }
      })
    },
    {
      name: '中度',
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        formatter: ({data}) => {
          if(data.value == 0){
            return ''
          }
          return `人数：${data.value}人\n占比：${(data.per).toFixed(2)}%`
        },
        fontSize: 10,
      },
      emphasis: {
        focus: 'series'
      },
      data: val.map((item) => {
        return {
          value:item.moderateData.numberPeople,
          per:item.moderateData.proportion
        }
      })
    },
    {
      name: '偏重',
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        formatter: ({data}) => {
          if(data.value == 0){
            return ''
          }
          return `人数：${data.value}人\n占比：${(data.per).toFixed(2)}%`
        },
        fontSize: 10,
      },
      emphasis: {
        focus: 'series'
      },
      data: val.map((item) => {
        return {
          value:item.biasedData	.numberPeople,
          per:item.biasedData	.proportion
        }
      })
    },
    {
      name: '严重',
      type: 'bar',
      stack: 'total',
      label: {
        show: true,
        formatter: ({data}) => {
          if(data.value == 0){
            return ''
          }
          return `人数：${data.value}人\n占比：${(data.per).toFixed(2)}%`
        },
        fontSize: 10,
      },
      emphasis: {
        focus: 'series'
      },
      data: val.map((item) => {
        return {
          value:item.seriousData.numberPeople,
          per:item.seriousData.proportion
        }
      })
    }
  ]
  chartInstance2 && chartInstance2.setOption(option);
}
</script>

<style lang="scss" scoped>
.page5{
  position: relative;
}
.page5 .content{
  padding: 40px;
  height: 100%;
}
.page5 .chart-content{
  padding: 20px;
  height: 100%;
  display: grid;
  grid-template-rows: 40% 60%;
}
.page5 .chartBox{
  display: grid;
  grid-template-rows: auto 1fr;
}
.page5 .bg-t{
  position: absolute;
  top: 0;
  right: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-rt.png") no-repeat;
  background-size: 100% 100%;
}
.page5 .bg-b{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-lb.png") no-repeat;
  background-size: 100% 100%;
}
</style>